import { motion } from 'framer-motion'
import { categorias, topCompras } from '../data'
import type { CategoriaFiltro } from '../App'

const icons: Record<string, string> = {
  Eletro: '⌁',
  Moda: '◇',
  Beleza: '✿',
  Esporte: '◬',
  Casa: '▢',
  Pet: '☉',
  Delivery: '◐',
  Farmácia: '+',
  Supermercado: '▤',
}

type Props = {
  onSelect: (cat: CategoriaFiltro) => void
}

export function Categorias({ onSelect }: Props) {
  return (
    <section id="categorias" className="bg-bone py-16 md:py-24">
      <div className="container-editorial">
        <header className="mb-10 md:mb-14">
          <div className="inline-flex items-center gap-3 mb-4">
            <span className="h-px w-8 bg-taupe" />
            <span className="text-xs tracking-[0.35em] uppercase text-taupe-dark font-medium">
              Categorias
            </span>
          </div>
          <h2 className="font-display font-light text-3xl md:text-5xl leading-[1.05] tracking-tighter text-ink max-w-3xl">
            Navegue por <em className="text-taupe-dark">setor</em>.
          </h2>
          <p className="mt-3 text-base text-ink/60 max-w-xl">
            Clique e vá direto ao ranking filtrado pela categoria.
          </p>
        </header>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categorias.map((cat, i) => {
            const count = topCompras.filter((c) => c.categoria === cat.nome).length
            const empty = count === 0
            return (
              <motion.button
                key={cat.nome}
                onClick={() => !empty && onSelect(cat.nome)}
                disabled={empty}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-40px' }}
                transition={{ duration: 0.5, delay: i * 0.04 }}
                className={`group relative text-left rounded-2xl p-6 md:p-7 transition-all ${
                  empty
                    ? 'bg-sand/15 border border-taupe/15 opacity-60 cursor-not-allowed'
                    : 'bg-sand/30 hover:bg-sand/60 border border-taupe/20 hover:border-ink/40 cursor-pointer'
                }`}
              >
                <div className="flex items-start justify-between mb-8">
                  <span aria-hidden="true" className={`font-display text-3xl md:text-4xl leading-none transition-colors ${
                    empty ? 'text-taupe/50' : 'text-taupe-dark/80 group-hover:text-terracotta'
                  }`}>
                    {icons[cat.nome]}
                  </span>
                  <span className="text-xs text-taupe tabular-nums">
                    {empty ? 'em breve' : `${count} ${count === 1 ? 'loja' : 'lojas'}`}
                  </span>
                </div>
                <h3 className="font-display text-xl md:text-2xl font-light text-ink leading-tight">
                  {cat.nome}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-ink/55 leading-snug">
                  {cat.descricao}
                </p>
                {!empty && (
                  <span className="absolute bottom-6 right-6 text-ink/30 group-hover:text-ink transition-colors text-lg">
                    →
                  </span>
                )}
              </motion.button>
            )
          })}
        </div>
      </div>
    </section>
  )
}
